/**
 * Single source of truth for venue + brand configuration.
 * No component should hardcode the club name, currency, or locale — read here.
 */
export const BRAND = {
  name: 'Break Point Club',
  shortCode: 'BPC',
  tagline: 'Smooth operations. Happier members. Better business.',
  version: '1.2.0',

  currency: 'INR',
  currencySymbol: '₹',
  locale: 'en-IN',
  timezone: 'Asia/Kolkata',
} as const;

/**
 * Supported station types. This is the closed set — the spec forbids inventing
 * others (no PlayStation, no chess, no unnamed stations).
 */
export const STATION_TYPES = ['POOL', 'MINI_SNOOKER', 'SNOOKER'] as const;
export type StationType = (typeof STATION_TYPES)[number];

export const STATION_TYPE_LABEL: Record<StationType, string> = {
  POOL: 'Pool',
  MINI_SNOOKER: 'Mini Snooker',
  SNOOKER: 'Snooker',
};

export type BrandConfig = typeof BRAND;
